export const apiPaths = {
  audit: {
    search: '/v1/mgmt/audit/search',
  },
};
